import { connectedStore } from '../../../store';
import constants from '../../constants';
import view from '../../../view';
import globals from '../../../globals';
import getCustomTextColorsStylesheet from './get-custom-text-color-stylesheet';
import template from '../../../template';
import { UPDATE_LIVE_ONLY } from '../../../hdrm/constants/update-strategies';

const { TEXT_COLOR_OPTIONS_VARIABLE } = constants;

const createCustomTextColorStylesheet = () => {
  const store = connectedStore.get();
  const state = store.getState();
  const variables = template.selectors.getVariables(state);

  const { id: targetTitle, globalId } = variables[TEXT_COLOR_OPTIONS_VARIABLE][0];
  const headerCodeGlobal = globals.selectors.getGlobal(state, globalId);
  const liveDom = view.accessors.getLiveDocument();

  const updateGlobalContentNode = globals.operations.changeGlobalContent(
    globalId,
    (globalFragment) => {
      const customColorStylesheetWrapper = liveDom.createElement('div');
      customColorStylesheetWrapper.setAttribute('id', targetTitle);
      const customColorStylesheet = liveDom.createElement('style');
      customColorStylesheet.setAttribute('title', targetTitle);

      customColorStylesheetWrapper.appendChild(customColorStylesheet);
      globalFragment.appendChild(customColorStylesheetWrapper);

      return globalFragment;
    },
    false
  );

  // update live dom without view reload
  const liveHeaderCodeGlobalNode = liveDom.querySelector(
    `ws-global[src*="${headerCodeGlobal.source}"]`
  );

  const elementId = view.accessors.getLiveElementId(liveHeaderCodeGlobalNode.firstElementChild);
  view.operations.replaceElement(updateGlobalContentNode, elementId, {
    strategy: UPDATE_LIVE_ONLY,
  });

  return getCustomTextColorsStylesheet();
};

export default createCustomTextColorStylesheet;
